"use client"

import styled, { css } from "styled-components"

export const Body = styled.div`
  ${({ theme }) => {
    const { colors } = theme

    return css`
      color: ${colors.fg};
      background-color: ${colors.bg};
      margin: 0;
      padding: 0;
      display: block;
      width: 100%;
      height: auto;
      min-height: 100vh;
    `
  }}
`
